import {Component, OnInit} from '@angular/core';
import {CrudService} from "@core/shared/services/crud.service";
import {CrudAction} from "@core/shared/models/crud";

@Component({
    selector: 'app-core-page-society-group-update',
    templateUrl: './page-society-group-update.component.html',
    styleUrls: ['./page-society-group-update.component.scss'],
    providers: [
        CrudService
    ],
    standalone: false
})
export class PageSocietyGroupUpdateComponent implements OnInit {

    constructor(
        private _crudService: CrudService
    ) {}

    ngOnInit() {

        this._crudService.setAction(CrudAction.Update);
    }
}
